// Y of the horizontal sibling-group bar: half-way between the parent/union and the children's
// generation row.
//
// It uses the children CENTROID (mean y), NOT the first child's y. For a normal sibship every
// child shares a generation row, so the centroid equals any child's y and this is identical to
// the old `(parentY + childNodes[0].y) / 2` form (a byte-identical change for all existing
// layouts). It only differs when a child has been freehand-moved off its row (Phase 3 "position
// anywhere, including between generations") — then anchoring the bar at the centroid keeps the
// bar and every child drop rendering cleanly instead of skewing toward the first child.
export function sibBarMidY(parentY, childNodes) {
  if (!childNodes || childNodes.length === 0) return parentY;
  const centroidY =
    childNodes.reduce((sum, n) => sum + (n.y ?? 0), 0) / childNodes.length;
  return (parentY + centroidY) / 2;
}
